export default __webpack_public_path__ + "static/media/iot.409bc08a.png";